@if (checked) {
  <i class="material-icons">
    {{ radio ? "radio_button_checked" : "check_box" }}
  </i>
} @else {
  <i class="material-icons">
    {{ radio ? "radio_button_unchecked" : "check_box_outline_blank" }}
  </i>
}
